// extracted by mini-css-extract-plugin
export default {"aiStarsAnimation":"AIStars_aiStarsAnimation__wULAR","sliding-stars":"AIStars_sliding-stars__jPVbF"};